export default __webpack_public_path__ + "static/media/15-Ernst&Young-Logo.02b6bde9.jpg";